import React from 'react';
import { clientPathLabel, indexClients } from '../../../utils/clientTree';
import { useI18n } from '../../../contexts/I18nContext';
import SearchableSelect from '../../common/SearchableSelect';
import { CreateDeviceState } from './useCreateDevice';

/** Who the device is: its identifier, its client, its type and its model. */
export const DeviceIdentitySection: React.FC<{ state: CreateDeviceState }> = ({ state }) => {
  const { t } = useI18n();
  const { form, errors } = state;

  return (
    <div className="device-section device-identity-section">
      <h3 className="section-title">{t('devices.deviceIdentity')}</h3>
      <div className="identity-fields-create">
        <div className="form-field">
          <label className="required" htmlFor="idDevice">{t('devices.deviceId')}</label>
          <input
            id="idDevice"
            name="idDevice"
            data-testid="field-device-id"
            type="text"
            value={form.idDevice}
            onChange={(e) => state.setField('idDevice', e.target.value.toUpperCase())}
            className={`field-input ${errors.idDevice ? 'error' : ''}`}
            placeholder={t('devices.deviceIdFormat')}
            maxLength={64}
          />
          {errors.idDevice && <span className="field-error">{errors.idDevice}</span>}
        </div>

        <div className="form-field">
          <label className="required">{t('devices.clientLabel')}</label>
          <SearchableSelect
            value={form.idClient}
            data-testid="field-device-client"
            onChange={(next) => state.setField('idClient', next)}
            className={`field-select ${errors.idClient ? 'error' : ''}`}
            placeholder={t('devices.selectClient')}
            options={state.clients.filter((c) => c.active !== false).map((client) => ({ value: String(client.id), label: clientPathLabel(client, indexClients(state.clients)) }))}
          />
          {errors.idClient && <span className="field-error">{errors.idClient}</span>}
        </div>

        <div className="form-field">
          <label>{t('devices.typeLabel')}</label>
          <SearchableSelect
            value={form.deviceType}
            data-testid="field-device-type"
            onChange={(next) => state.setField('deviceType', next)}
            className="field-select"
            placeholder={t('devices.selectType')}
            options={state.hardwareTypes.filter((type) => type.is_active).map((type) => ({ value: type.code, label: `${type.name} (${type.code})` }))}
          />
        </div>

        <div className="form-field">
          <label>{t('devices.modelLabel')}</label>
          <SearchableSelect
            value={form.model}
            onChange={(next) => state.setField('model', next)}
            className="field-select"
            disabled={!form.deviceType || state.modelRefs.length === 0}
            placeholder={t('devices.selectModel')}
            options={state.modelRefs.filter((ref) => ref.is_active).map((ref) => ({ value: ref.code, label: `${ref.code}${ref.name ? ` - ${ref.name}` : ''}` }))}
          />
        </div>
      </div>
    </div>
  );
};
